<template>
  <el-dialog
    v-bind="$attrs"
    title="Кандидат рассматривался ранее"
    :width="$attrs.width"
    :visible="is_visible"
    :close-on-click-modal="false"
    class="dialog"
    @close="$emit('cancel-callback')"
  >
    <div v-if="popupData?.metadata?.panels.length">
      <p
        v-for="(text, key) in popupData.metadata.panels[0].rows"
        :key="key"
        class="dialog__text"
        v-html="formatHtml(text[0].value)"
      ></p>
    </div>
    <div slot="footer" v-if="buttonsMeta.length">
      <FormButtons
        :buttons_menu="buttonsMeta"
        view-type="detail"
        @CallPopup="callGeneralPopup"
        @ClosePopup="$emit('cancel-callback')"
      ></FormButtons>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import { store } from '@/store';
import FormButtons from 'Elements/Form/FormButtons';
import { mixin } from '@/utils/mixins';
import { BUTTON, INTENT_AREA, INTENT_TYPE } from '@/utils/constants';
export default {
  inheritAttrs: false,
  mixins: [mixin],
  props: {
    is_visible: {
      type: Boolean
    }
  },
  computed: {
    popupData() {
      return store.state.common.visible_dialog.warning_sb_dialog.data || {};
    },
    buttonsMeta() {
      return (
        this.popupData?.metadata?.buttons_menu.map(row =>
          row.map(btn =>
            btn.id == BUTTON.ID.SAVE && btn.lbl.name == 'LBL_BUTTON_YES'
              ? {
                  ...btn,
                  intents: [
                    {
                      intentArea: INTENT_AREA.CALL_GENERAL_POPUP
                    },
                    ...btn.intents
                  ]
                }
              : btn
          )
        ) || []
      );
    }
  },
  methods: {
    callGeneralPopup() {
      for (let index in this.popupData.intents) {
        if (
          this.popupData.intents[index].intentArea ==
            INTENT_AREA.CUSTOM_POPUP &&
          this.popupData.intents[index].intentType == INTENT_TYPE.EDIT
        ) {
          store.commit('common/setVisibleDialog', {
            name: 'general_dialog',
            val: true,
            params: this.popupData.intents.slice(Number(index) + 1)
          });
        }
      }
    }
  },
  components: { 'el-dialog': Dialog, FormButtons }
};
</script>
<style lang="scss" scoped>
.dialog {
  &__text {
    font-size: 16px !important;
  }
}
</style>
